import { render } from "./EditWorkWeek.vue?vue&type=template&id=44a7d394&scoped=true"
import script from "./EditWorkWeek.vue?vue&type=script&lang=js"
export * from "./EditWorkWeek.vue?vue&type=script&lang=js"

import "./work-shift.scss?vue&type=style&index=0&id=44a7d394&lang=scss&scoped=true"

import exportComponent from "/home/paperspace/thehrway-basic/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a7d394"]])

export default __exports__